import { useI18n, catLabel } from "../lib/i18n";
import { uniqueCats } from "../lib/cats";

const orderCats = (cats, order) => {
  const idx = (c) => {
    const i = order.findIndex((o) => o.toLowerCase() === c.toLowerCase());
    return i === -1 ? 999 : i;
  };
  return [...cats].sort((a, b) => idx(a) - idx(b) || a.localeCompare(b));
};

export const CategoryGrid = ({ products, order = [], icons = {}, cat, setCat, prefix }) => {
  const { t, lang } = useI18n();
  const cats = orderCats(uniqueCats(products.map((p) => p.category)), order);
  if (cats.length < 2) return null;

  const pickCat = (value) => {
    setCat(value);
    requestAnimationFrame(() =>
      document
        .getElementById("catalog-section")
        ?.scrollIntoView({ behavior: "smooth", block: "start" })
    );
  };
  const cover = (c) =>
    icons[c] ||
    Object.entries(icons).find(([k]) => k.toLowerCase() === c.toLowerCase())?.[1] ||
    products.find((p) => (p.category || "").toLowerCase() === c.toLowerCase() && p.image_url)
      ?.image_url;

  return (
    <div data-testid={`${prefix}-category-grid`}>
      <p className="font-display text-lg md:text-lg font-semibold mb-3">{t("browse_category")}</p>
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3">
        {cats.map((c) => {
          const on = cat?.toLowerCase() === c.toLowerCase();
          return (
            <button
              key={c}
              data-testid={`${prefix}-cat-tile-${c}`}
              onClick={() => pickCat(on ? "__all__" : c)}
              className={`group relative overflow-hidden rounded-2xl aspect-square text-left transition-all duration-300 hover:-translate-y-1 ${
                on ? "ring-2 ring-primary" : ""
              }`}
            >
              {cover(c) ? (
                <img
                  src={cover(c)}
                  alt={c}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              ) : (
                <span className="absolute inset-0 bg-gray-200" />
              )}
              <span className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
              <span className="absolute bottom-2 left-2.5 right-2 text-white text-xs sm:text-sm font-medium leading-tight">
                {catLabel(c, lang)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
